// Package Imports
import React from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { Authenticated } from '@refinedev/core';
import {
  CatchAllNavigate,
  NavigateToResource,
} from '@refinedev/react-router-v6';
import { ThemedLayoutV2 } from '@refinedev/antd';

// Project Imports
import DashboardRoute from 'core/routes/DashboardRoute';
import ErrorRoute from 'core/routes/ErrorRoute';
import LoginRoute from 'core/routes/LoginRoute';
import Header from 'components/header';
import routeName from 'core/common/routeName';

import CustomSider from 'components/sider/sider';
import PayoutInitializationRoute from 'core/routes/PayoutInitializationRoute';
import InputFileUploadRoute from 'core/routes/InputFileUploadRoute';
import MasterUploadRoute from 'core/routes/MasterUploadRoute';
// import InputFileDownloadRoute from 'core/routes/InputFileDownloadRoute';
import MasterDownloadRoute from 'core/routes/MasterDownloadRoute';
import MyTaskRoute from 'core/routes/MyTaskRoute';
import PayoutHistoryRoute from 'core/routes/PayoutHistoryRoute';
import UnificationHistoryRoute from 'core/routes/UnificationList';
import ProfileRoute from 'core/routes/ProfileRoute';
import AccountingRoute from 'core/routes/AccountingRoute';
import ChartMappingRoute from 'core/routes/ChartMappingRoute';
import ChartRoute from 'core/routes/ChartRoute';
import DashboardChartMappingRoute from 'core/routes/DashboardChartMappingRoute';
import OverviewRoute from 'core/routes/OverviewRoute';
import RunSimulationRoute from 'core/routes/RunSimulationRoute';
import ViewSimulationRoute from 'core/routes/ViewSimulationRoute';
// import RuleDetailsRoute from 'core/routes/RuleDetailsRoute';
import SyncManagementRoute from 'core/routes/SyncManagementRoute';
import SyncHistoryRoute from 'core/routes/SyncHistoryRoute';
import PerformanceDashboardRoute from 'core/routes/PerformanceDashboardRoute';

import TargetSettingRoute from 'core/routes/TargetSettingRoute';
import HistoricalRoute from 'core/routes/HistorialRoute';
import UserPerfomanceRoute from 'core/routes/UserPerfomanceRoute';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import usePermission from 'core/utils/usePermission';
import TargetOverrideRoute from 'core/routes/TargetOverride';
import CalSummary from 'pages/calculation/calSummary';
import AttributeReview from 'pages/attributeReview/AttributeReview';
import RaiseQueryRoute from 'core/routes/RaiseQuery';
import TeamleadDashboardRoute from 'core/routes/TeamleadDashboardRoute';
import CancellationFileUploadRoute from 'core/routes/ClawbackFileUploadRoute';
import TriggerClawbackRoute from 'core/routes/TriggerClawbackRoute';
import UserPerformanceRoute from 'core/routes/TeamMemberPerformanceRoute';
import NeedToPayRoute from 'core/routes/NeedToPayRoute';
import UploadUtrRoute from 'core/routes/UploadUtrRoute';
import PayoutAdminTaskRoute from 'core/routes/PayoutAdminTaskRoute';
import PayoutReportRoute from 'core/routes/PayoutReportRoute';
import ConfigReportRoute from 'core/routes/ConfigReportRoute';
import NoDuesCertificateRoute from 'core/routes/NoDuesCertificateRoute';
import CouponsRoute from 'core/routes/CouponsRoute';
import CouponConfirmationPage from 'core/routes/CouponConfirmationRoute';
import HoldUnholdTaskConfigRoute from 'core/routes/HoldUnholdTaskConfigRoute';
import HoldRoute from 'core/routes/HoldRoute';
import UnholdRoute from 'core/routes/UnholdRoute';
import TaskConfigRoute from 'core/routes/TaskConfigRoute';
import ContestHistoryRoute from 'core/routes/ContestHistoryRoute';
import ContestInitializationRoute from 'core/routes/ContestInitializationRoute';
import InputFileDataCorrectionRoute from 'core/routes/InputFileDataCorrectionRoute';
import MasterFileDataCorrectionRoute from 'core/routes/MasterFileDataCorrection';
import ConfigReportChangeRoute from 'core/routes/ConfigReportChange';
import RecalcUploadRoute from 'core/routes/RecalcUploadRoute';
import RecalcCalculateRoute from 'core/routes/RecalcCalculateRoute';
import QueryReportRoute from 'core/routes/QueryReportRoute';
import InvoiceReportRoute from 'core/routes/InvoiceReportRoute';

const AppRoutes: React.FC = () => {
  const checkPermission = usePermission();

  return (
    <Routes>
      <Route
        element={
          <Authenticated fallback={<CatchAllNavigate to={routeName.login} />}>
            <ThemedLayoutV2
              Header={() => <Header />}
              Sider={() => <CustomSider />}
            >
              <Outlet />
            </ThemedLayoutV2>
          </Authenticated>
        }
      >
        <Route
          index
          element={
            <NavigateToResource
              resource={
                checkPermission(PrivateRouteConst.PERFORMANCE_DASHBOARD)
                  ? routeName.performanceDashboard
                  : routeName.dashboard
              }
            />
          }
        />
        <Route path="cal-summary">
          <Route index element={<CalSummary />} />
        </Route>
        <Route path="attribute-review">
          <Route index element={<AttributeReview />} />
        </Route>

        {PerformanceDashboardRoute}
        {DashboardRoute}

        {MyTaskRoute}
        {RunSimulationRoute}
        {ViewSimulationRoute}
        {ErrorRoute}
        {PayoutInitializationRoute}
        {InputFileUploadRoute}
        {MasterUploadRoute}
        {/* {InputFileDownloadRoute} */}
        {MasterDownloadRoute}
        {UnificationHistoryRoute}
        {PayoutHistoryRoute}
        {AccountingRoute}
        {ProfileRoute}
        {ChartMappingRoute}
        {ChartRoute}
        {DashboardChartMappingRoute}
        {OverviewRoute}
        {/* {RuleDetailsRoute} */}
        {SyncHistoryRoute}
        {SyncManagementRoute}
        {TargetSettingRoute}
        {HistoricalRoute}
        {UserPerfomanceRoute}
        {TargetOverrideRoute}
        {RaiseQueryRoute}
        {TeamleadDashboardRoute}
        {CancellationFileUploadRoute}
        {TriggerClawbackRoute}
        {UserPerformanceRoute}
        {NeedToPayRoute}
        {UploadUtrRoute}
        {PayoutAdminTaskRoute}
        {PayoutReportRoute}
        {ConfigReportRoute}
        {ConfigReportChangeRoute}
        {NoDuesCertificateRoute}
        {CouponsRoute}
        {CouponConfirmationPage}
        {HoldUnholdTaskConfigRoute}
        {HoldRoute}
        {UnholdRoute}
        {TaskConfigRoute}
        {ContestHistoryRoute}
        {ContestInitializationRoute}
        {InputFileDataCorrectionRoute}
        {MasterFileDataCorrectionRoute}
        {RecalcUploadRoute}
        {RecalcCalculateRoute}
        {QueryReportRoute}
        {InvoiceReportRoute}
      </Route>
      {ErrorRoute}
      <Route
        element={
          <Authenticated fallback={<Outlet />}>
            <NavigateToResource />
          </Authenticated>
        }
      >
        {LoginRoute}
      </Route>
    </Routes>
  );
};

export default AppRoutes;
